import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      bg="primary"
      variant="dark"
      className="py-4"
    >
      <Container className="font">
        <Navbar.Brand as={HashLink} to="/">
          Moshiur Rahman Akash
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={HashLink} to="/home#projects">
              Projects
            </Nav.Link>

            <Nav.Link as={HashLink} to="/portfolio">
              Portfolio
            </Nav.Link>
            <Nav.Link as={HashLink} to="/blogs">
              My Blogs
            </Nav.Link>
            <Nav.Link as={HashLink} to="/aboutMe">
              About Me
            </Nav.Link>
            <Nav.Link as={HashLink} to="/home#contactMe">
              Contact Me
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
